import moment from "moment";

export const TARJETA_COLORS = {
    green: "#006465",
};

export const TARJETA = {
    cedula: "",
    nombreCliente: "",
    corporativo: false,
    fechaClienteDesde: null,
};

export const localDateToMoment = localDate => {
    if (!localDate) return "";
    try {
        const date = new Date(localDate);
        return moment(date).format("DD / MM / YYYY");
    } catch (e) {
        return "";
    }
};
